import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function usePrepareVideoPreview() {
  const client = useQueryClient();
  const mutation = useMutation({
    mutationFn: (videoId: string) =>
      apiClient.post<{ ready: boolean }>(
        `videos/${videoId}/prepare-preview`,
        {}
      ),
    onSuccess: async (_data, videoId) => {
      await client.invalidateQueries({
        queryKey: queryKeys.video.detail(videoId),
      });
    },
  });
  return {
    prepareVideoPreviewAsync: mutation.mutateAsync,
    isPreparing: mutation.isPending,
  };
}
